//@flow
import type { ReducerState$Type,EditForm$Type } from '../genericFlowTypes'

export const transformDataToEditFormData=(data:any,orion: ReducerState$Type)=>{
    let formData: EditForm$Type = {}
    
    const uranusResultsetData = data['uranusResultset']
    formData.isInvalidDoc = uranusResultsetData['is_invalid_doc']?uranusResultsetData['is_invalid_doc']:false
    formData.isOverrideVendorName = uranusResultsetData['is_override_vendor_name']?uranusResultsetData['is_override_vendor_name']:false
    
    if (uranusResultsetData['inv_no']){
        formData.invNo = uranusResultsetData['inv_no']
    }
    if (uranusResultsetData['inv_date']){
        formData.invDate = uranusResultsetData['inv_date']
    }
    if (uranusResultsetData['po_no']){
        formData.poNo = uranusResultsetData['po_no']
    }
    if (uranusResultsetData['total']){
        formData.total = parseFloat(uranusResultsetData['total'])
    }
    if (uranusResultsetData['vendor_name']){
        formData.vendorName = uranusResultsetData['vendor_name']
    }
    
    return formData
}


// WEBPACK FOOTER //
// ./src/redux/uranus/editFormData.js